import { render, staticRenderFns } from "./salesCouponRecord.vue?vue&type=template&id=40953044&scoped=true&"
import script from "./salesCouponRecord.vue?vue&type=script&lang=js&"
export * from "./salesCouponRecord.vue?vue&type=script&lang=js&"
import style0 from "./salesCouponRecord.vue?vue&type=style&index=0&id=40953044&scoped=true&lang=css&"
import style1 from "./salesCouponRecord.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40953044",
  null
  
)

export default component.exports